/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import getEmploiInformationInscritesActions, {
    getEmploiInformationInscritesTypes,
} from '../../../../redux/editique/donneesEmploi/getEmploiInformationInscrites'
import { Get } from '../../../../serveur/axios'

function* getEmploiInformationInscritesSagas({ response }) {
    const {
        governorate,
        delegation,
        bureauEmploi,
        from,
        to,
        fromSecondary,
        toSecondary,
    } = response

    let url = '/editique-emploi/emploi_entreprises_inscrites?'

    if (governorate) {
        url = `${url}&governorate=${governorate}`
    }
    if (delegation) {
        url = `${url}&delegation=${delegation}`
    }
    if (bureauEmploi) {
        url = `${url}&bureau_emploi=${bureauEmploi}`
    }
    if (from) {
        url = `${url}&from=${from}`
    }
    if (to) {
        url = `${url}&to=${to}`
    }
    if (fromSecondary) {
        url = `${url}&fromSecondary=${fromSecondary}`
    }
    if (toSecondary) {
        url = `${url}&toSecondary=${toSecondary}`
    }

    try {
        const res = yield Get(url)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getEmploiInformationInscritesActions.getEmploiInformationInscritesSuccess(
                        res.data.data
                    )
                ),
            ])
        } else {
            yield put(
                getEmploiInformationInscritesActions.getEmploiInformationInscritesFailure(
                    res.data.data
                )
            )
        }
    } catch (error) {
        yield put(
            getEmploiInformationInscritesActions.getEmploiInformationInscritesFailure(
                error
            )
        )
    }
}

export function* getEmploiInformationInscritesSaga() {
    yield takeLatest(
        getEmploiInformationInscritesTypes.GET_EMPLOI_INFORMATION_INSCRITES_REQUEST,
        getEmploiInformationInscritesSagas
    )
}
